import { Outlet } from 'react-router-dom';
import { AppStatusBar } from './AppStatusBar';

export function PosLayout() {
  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <AppStatusBar />
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
